export const HistoryItemName = 'HistoryItemComponent';
